/**
 * 创客坛
 */

import Container from '@/containers';

const meetingRouter = {
    path: '/meeting',
    component: Container,
    redirect: '/meeting/index',
    name: 'Meeting',
    meta: {
        title: '创客坛'
    },
    children: [
        {
            path: 'index',
            component: () => import('@/views/meeting/index'),
            name: 'MeetingIndex',
            meta: {
                title: '首页',
                showAddBtn:true
            }
        },
        {
            path: 'detail',
            component: () => import('@/views/meeting/detail'),
            name: 'MeetingDetail',
            meta: {
                title: '会议详情',
                showAddBtn:true
            }
        },
        {
            path: 'apply',
            component: () => import('@/views/meeting/apply'),
            name: 'MeetingApply',
            meta: {
                title: '会议报名'
            }
        },
        {
            path: 'preview',
            component: () => import('@/views/meeting/applyPreview'),
            name: 'MeetingApplyPreview',
            meta: {
                title: '会议报名'
            }
        },
        {
            path: 'join',
            component: () => import('@/views/meeting/join'),
            name: 'MeetingJoin',
            meta: {
                title: '腾讯会议'
            }
        },
        {
            path: 'create',
            component: () => import('@/views/meeting/create'),
            name: 'CreateMeeting',
            meta: {
                title: '申请创建会议'
            }
        }
    ]
};

export default meetingRouter;
